import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08730764")

_pushScopeId("data-v-08730764")
const _hoisted_1 = { class: "blue" }
const _hoisted_2 = { class: "label-wrap" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "side-name" }
const _hoisted_5 = { class: "cards-wrap" }
const _hoisted_6 = { class: "card third-card" }
const _hoisted_7 = { class: "card second-card" }
const _hoisted_8 = { class: "card first-card" }
const _hoisted_9 = { class: "red" }
const _hoisted_10 = { class: "label-wrap" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "side-name" }
const _hoisted_13 = { class: "cards-wrap" }
const _hoisted_14 = { class: "card first-card" }
const _hoisted_15 = { class: "card second-card" }
const _hoisted_16 = { class: "card third-card" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["good-road-card-result-root", {
            'is-dragon-tiger': _ctx.isDragonTiger,
            'is-desktop': _ctx.isDesktop
        }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["set-of-cards-wrap", { flashing: _ctx.isBlueSideWin }]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.blueTotal), 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.blueLabel), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_ctx.blueHand.length > 2)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue3rdCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.blueHand.length > 1)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue2ndCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_8, [
            (_ctx.blueHand.length > 0)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue1stCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", {
        class: ["set-of-cards-wrap", { flashing: _ctx.isRedSideWin }]
      }, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.redTotal), 1),
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.redLabel), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            (_ctx.redHand.length > 0)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.red1stCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_15, [
            (_ctx.redHand.length > 1)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.red2ndCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_16, [
            (_ctx.redHand.length > 2)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.red3rdCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ])
  ], 2))
})